<template>
  <ul class="main-product__sidebar-usp">
    <template
      v-for="(block, index) of blocks"
      :key="index"
    >
      <li
        v-if="content[block.text]"
        class="text-body-l-regular"
      >
        <div class="main-product__sidebar-usp-icon">
          <responsive-image
            v-if="block.icon.src"

            :image="{
              src: block.icon.src
            }"
            ratio="1:1"
          />
        </div>

        <span
          v-if="content[block.text]"
          v-text="content[block.text]"
        />
      </li>
    </template>
  </ul>
</template>

<script>
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'MainProductSidebarUsp',
  components: {
    ResponsiveImage,
  },
  props: {
    blocks: {
      type: [Array],
      default: () => {
        return []
      },
    },

    content: {
      type: [Object],
      default: () => {
        return {}
      },
    },
  },
}
</script>
